import $ from 'jquery';

const ACTIVE = 'nav-open';

const nav = () => {
  const navToggle = $('.js-nav-toggle');
  const body = $('body');
  navToggle.on('click', ev => {
    ev.preventDefault();
    body.toggleClass(ACTIVE);
  });
};
export default nav;



// WEBPACK FOOTER //
// ./src/scripts/modules/nav.js